import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { ROUTES } from '../../config/routes';

const NavigationBlockModal = ({ isOpen, onConfirm, onCancel }) => {
const { logout } = useAuth();

if (!isOpen) return null;

/**
 * 登録フロー関連のクッキーを削除
 */
const clearRegistrationCookies = () => {
  const registrationCookieKeys = [
    'registration_current_step',
    'registration_completed_steps', 
    'registration_data',
    'registration_flow_completed', 
    'termsAgreementSession',
    'stepCompletionTimes',
    'currentStepToken'
  ];
  
  registrationCookieKeys.forEach(key => {
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  });
};

/**
 * すべてのクッキーを削除
 */
const clearAllCookies = () => {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const cookieName = cookie.split('=')[0].trim();
    if (cookieName) {
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
  }
};

/**
 * 「ページを離れる」ボタンのクリックハンドラー
 * ログアウト処理を実行してから利用規約ページへ遷移
 */
const handleConfirmAndLogout = async () => {
  try {
    
    // onConfirmコールバックが渡されていれば先に実行
    if (onConfirm) {
      onConfirm();
    }

    // ログアウト処理を実行
    if (logout) {
      await logout();
    }
    
  } catch (error) {
    console.error('[NAVIGATION MODAL] Logout failed:', error);
  } finally {
    // すべてのデータをクリア
    try {
      
      clearRegistrationCookies();
      clearAllCookies();
      
    } catch (clearError) {
      console.error('[NAVIGATION MODAL] Failed to clear data:', clearError);
    }
    
    // 利用規約画面へ強制遷移   
    // 少し待機してから遷移
    setTimeout(() => {
      window.location.href = ROUTES.TERMS;
    }, 100);
  }
};

  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999
  };

  const modalStyle = {
    backgroundColor: 'white',
    padding: '30px',
    borderRadius: '8px',
    maxWidth: '500px',
    width: '90%',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
  };

  const titleStyle = {
    fontSize: '20px',
    fontWeight: 'bold',
    marginBottom: '15px',
    color: '#333'
  };

  const messageStyle = {
    fontSize: '16px',
    marginBottom: '25px',
    color: '#666',
    lineHeight: '1.5'
  };

  const buttonContainerStyle = {
    display: 'flex',
    gap: '10px',
    justifyContent: 'flex-end'
  };

  const buttonStyle = {
    padding: '10px 20px',
    borderRadius: '4px',
    border: 'none',
    fontSize: '14px',
    cursor: 'pointer',
    fontWeight: 'bold'
  };

  const cancelButtonStyle = {
    ...buttonStyle,
    backgroundColor: '#6c757d',
    color: 'white'
  };

  const confirmButtonStyle = {
    ...buttonStyle,
    backgroundColor: '#dc3545',
    color: 'white'
  };

  return (
    <div style={overlayStyle} onClick={onCancel}>
      <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
        <h2 style={titleStyle}>ページを離れますか?</h2>
        <p style={messageStyle}>
          <span>入力中のデータが失われます。</span><br />
          <span>本当にこのページから移動しますか?</span>
        </p>
        <div style={buttonContainerStyle}>
          <button 
            style={cancelButtonStyle}
            onClick={onCancel}
          >
            キャンセル
          </button>
          <button 
            style={confirmButtonStyle}
            onClick={handleConfirmAndLogout}
          >
            ページを離れる
          </button>
        </div>
      </div>
    </div>
  );
};

export default NavigationBlockModal;